'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  // fixed header
  if (!$('body').hasClass('not-found-page')) {
    if (window.innerWidth < 1024) {
      $('.header').addClass('fixed');
      $('.wrapper').css('padding-top', '61px');
    }
  }

  // mobile-menu
  $('.hamb__lines').on('click', function () {
    $('.hamb__menu').addClass('active');
    $('body, html').css('overflow', 'hidden');
  });
  $('.hamb__close').on('click', function () {
    $('.hamb__menu').removeClass('active');
    $('body, html').css('overflow', '');
  });
  $('.dropdown').on('click', function () {
    $('.dropdown-menu').slideToggle(500);
  });
};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/components/header.js
// module id = 6
// module chunks = 0